import { requestFactory } from '@/plugins/axios'
// {productId}
export function fetchData(params) {
  return requestFactory({
        url: '/productOrder/detailedInformation',
        method: 'GET',
        params: params
      })
}
// {page,size}
export function getTemplete(params) {
  return requestFactory({
        url: '/Template/list',
        method: 'GET',
        params: params
      })
}
// {page,size}
export function getMachineList(data) {
   return requestFactory({
        url: '/machine/findList',
        method: 'GET',
        params: data
      })
}
// {productTask}
export function onSubmitupdata(data) {
   return requestFactory({
        url: `/productOrder/update/${this.$route.params.id}`,
        method: 'PUT',
        data: data
      })
}

// {productTask}
export function onSubmitsave(data) {
    return requestFactory({
        url: '/productOrder/save',
        method: 'POST',
        data: data
      })
 }
 export function deleteSubmit(id) {
    return requestFactory({
        url: `/Template/delete/${id}`,
        method: 'DELETE'
      })
 }
